import { appConfig } from 'cd-eft/config/AppConfig';
import * as AUTH from 'cd-eft/_codegen_/openapi-generator/eft-authen';

const authConfig = new AUTH.Configuration({ basePath: appConfig.endpoints.eftAuthenApiBasePath });

export const TokenController = new AUTH.TokenControllerApi(authConfig);
export const ServiceStatusController = new AUTH.ServiceStatusControllerApi(authConfig);

export async function generateAccessToken(username: string, password: string) {
  const response = await TokenController.generateTokenUsingPOST({ username: username, password: password });
  const data = response.data;
  return data;
}

export async function revokeAccessToken(username: string) {
  const response = await TokenController.invalidateTokenUsingPOST({ username: username });
  const data = response.data;
  return data;
}

export async function extendAccessToken(refreshToken: string) {
  const response = await TokenController.extendTokenUsingPOST({ refreshToken: refreshToken });
  const data = response.data;
  return data;
}

export async function validateAccessToken(accessToken: string) {
  const response = await TokenController.validateAccessTokenUsingPOST({ accessToken: accessToken });
  const data = response.data;
  return data;
}

// console.log('!!!! EFT-AUTHEN API INITIALIZED !!!!');
